import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";

import {
  Container,
  Card,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Table,
  UncontrolledDropdown,
  UncontrolledTooltip
} from "reactstrap";


import ToastDialog from "components/Common/ToastDialog";
import { addUser, editUser, getUser } from "http/fundLync/user.helper";
import { decryptedValue } from "common/utility";

const AddUsers = () => {
  const [isEdit, setIsEdit] = useState(false);
  const [userList, setUserList] = useState([]);
  const user = decryptedValue(localStorage.getItem("user"));
  const entityId = user.entityId;
  const [userEditData, setUserEditData] = useState(null);
  const [toastInfo, setToastInfo] = useState({ showToast: false });

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      firstName: userEditData && userEditData[0]?.firstName || "",
      lastName: userEditData && userEditData[0]?.lastName || "",
      email: userEditData && userEditData[0]?.email || "",
      mobileNo: userEditData && userEditData[0]?.mobileNo || "",
      roleId:userEditData &&  userEditData[0]?.roleId || "",
      id:userEditData &&  userEditData[0]?.id || "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("Please Enter First Name"),
      lastName: Yup.string().required("Please Enter Last Name"),
      email: Yup.string().required("Please Enter email").email("Invalid Email"),
      mobileNo: Yup.string()
        .required("Please Enter Mobile Number")
        .matches(/^\d{10}$/, "Mobile Number must be exactly 10 digits"),
      roleId: Yup.string().required("Please choose your role")
    }),
    onSubmit: (values) => {
      if (isEdit) {
        const entity = {
          id: values.id,
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          mobileNo: String(values.mobileNo),
          roleId: values.roleId,
          entityId,
        };
        editUser(entity)
          .then((response) => {
            if (response.code == 201 && response.status) {
              validation.resetForm()
              setToastInfo({
                message: "User Saved",
                showToast: true,
                role: "success",
              })
              getUser({ entityId })
                .then((response) => {
                  if (response.code == 200 && response.status) {
                    setUserList(response?.data?.data)
                  }
                })
                .catch((error) => {
                  console.log(error)
                })
            } else {
              const { message } = response;
              setToastInfo({
                message: message,
                showToast: true,
                role: "error",
              });
            }
          })
          .catch((error) => {
            console.log(error)
          })
      } else {
        const entity = {
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          mobileNo: String(values.mobileNo),
          roleId: values.roleId,
          entityId,
        };
        addUser(entity)
          .then((response) => {
            if (response.status) {
              validation.resetForm()
              setToastInfo({
                message: "User Saved",
                showToast: true,
                role: "success",
              })
              getUser({ entityId })
                .then((response) => {
                  if (response.code == 200 && response.status) {
                    setUserList(response?.data?.data)
                  }
                }).catch((error) => {
                  console.log(error)
                })
            } else {
              const { message } = response;
              setToastInfo({
                message: message,
                showToast: true,
                role: "error",
              });
            }
          })
          .catch((error) => {
            console.log(error)
          })
      }

    },
  });

  useEffect(() => {
    getUser({ entityId })
      .then((response) => {
        if (response.code == 200 && response.status) {
          setUserList(response?.data?.data)
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }, []);



  const handleCancelrClicks = () => {
    if (isEdit) {
      setUserEditData(null);
      setIsEdit(false);
    } else {
      validation.resetForm();
      window.history.back()
    }

  };

  const EditAddress = (id) => {
    setIsEdit(true);
    const filteredData = userList.filter((elem) => {
      return elem.id == id;
    });
    setUserEditData(filteredData);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row className="vertical-scroll">
            <div>
              <div>
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}
                >
                  <div>
                    <h4 style={{ marginTop: "1%" }}>Add User</h4>
                  </div>

              <Row className="mb-30">
                <Col sm="12" md="6">
                  <Label className="form-label mt-4">First Name*</Label>
                  <Input
                    name="firstName"
                    type="text"
                    placeholder="Insert First Name"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.firstName || ""}
                    invalid={
                      validation.touched.firstName &&
                        validation.errors.firstName
                    }
                  />
                  {validation.touched.firstName &&
                    validation.errors.firstName ? (
                    <FormFeedback type="invalid">
                      {validation.errors.firstName}
                    </FormFeedback>
                  ) : null}
                </Col>

                <Col sm="12" md="6">
                  <Label className="form-label mt-4">Last Name</Label>
                  <Input
                    name="lastName"
                    type="text"
                    placeholder="Insert Last Name"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.lastName || ""}
                    invalid={
                      validation.touched.lastName &&
                        validation.errors.lastName
                    }
                  />
                  {validation.touched.lastName &&
                    validation.errors.lastName ? (
                    <FormFeedback type="invalid">
                      {validation.errors.lastName}
                    </FormFeedback>
                  ) : null}
                </Col>

                <Col sm="12" md="6">
                  <Label className="form-label mt-4">Email*</Label>
                  <Input
                    name="email"
                    type="email"
                    placeholder="Insert Email"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.email || ""}
                    invalid={
                      validation.touched.email && validation.errors.email
                    }
                  />
                  {validation.touched.email && validation.errors.email ? (
                    <FormFeedback type="invalid">
                      {validation.errors.email}
                    </FormFeedback>
                  ) : null}
                </Col>

                <Col sm="12" md="6">
                  <Label className="form-label mt-4">Mobile No.*</Label>
                  <Input
                    name="mobileNo"
                    type="number"
                    placeholder="Insert Mobile No"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.mobileNo || ""}
                    invalid={
                      validation.touched.mobileNo &&
                        validation.errors.mobileNo
                    }
                  />
                  {validation.touched.mobileNo &&
                    validation.errors.mobileNo ? (
                    <FormFeedback type="invalid">
                      {validation.errors.mobileNo}
                    </FormFeedback>
                  ) : null}
                </Col>

                <Col sm="12" md="6">
                  <Label className="form-label mt-4">Role*</Label>
                  <Input
                    name="roleId"
                    type="select"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.roleId || ""}
                    invalid={validation.touched.roleId && validation.errors.roleId}
                  >
                    <option value="" disabled>Select Role</option>
                    <option value="3">Financier Admin</option>
                    <option value="4">Financier Operation</option>
                  </Input>
                  {validation.touched.roleId && validation.errors.roleId ? (
                    <FormFeedback type="invalid">{validation.errors.roleId}</FormFeedback>
                  ) : null}
                </Col>
              </Row>

                  <div className="mb-3 d-flex" style={{ width: "100%" }}>
                  </div>

              <Row>
                <Col>
                <div className="d-flex gap-3 justify-content-end mb-3">
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                      onClick={handleCancelrClicks}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-success save-customer"
                    >
                      {isEdit ? "Update" : "+ Add"}
                    </button>
                  </div>
                </Col>
              </Row>
            </Form>
          </div>

          <Row>
            <Col xs="12">
              <div className="table-responsive mb-3">
                <Table className="table table-bordered mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>Id</th>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Email</th>
                      <th>Mobile</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userList.length == 0 ?
                      <tr>
                        <td colSpan={6} className="text-center">No data found</td>
                      </tr> :
                      (userList.map((elem, index) => (
                        <tr key={elem.id}>
                          <td>{index + 1}</td>
                          <td>{elem.firstName || "-"}</td>
                          <td>{elem.lastName || "-"}</td>
                          <td>{elem.email}</td>
                          <td>{elem.mobileNo}</td>
                          <td>
                            <UncontrolledDropdown>
                              <DropdownToggle tag="a" className="card-drop">
                                <i className="mdi mdi-dots-horizontal font-size-18"></i>
                              </DropdownToggle>

                                  <DropdownMenu className="dropdown-menu-end">
                                    <DropdownItem
                                      onClick={() => {
                                        EditAddress(elem.id);
                                      }}
                                    >
                                      <i
                                        className="mdi mdi-pencil font-size-16 text-success me-1"
                                        id="edittooltip"
                                      ></i>
                                      Edit
                                      <UncontrolledTooltip
                                        placement="top"
                                        target="edittooltip"
                                      >
                                        Edit
                                      </UncontrolledTooltip>
                                    </DropdownItem>
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              </td>
                            </tr>
                          )))}
                      </tbody>
                    </Table>
                  </div>
                </Col>
              </Row>
            </div>
          </Row>
        </Container>
      </div>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </React.Fragment>
  );
}

export default AddUsers;
